import { Link, useMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import OnlineDot from '@/components/atoms/OnlineDot';
import { PAGE_PATHS } from '@/routes/const';
import { useUnreadStore } from '@/stores/useUnreadStore';

/** P1 tab avatar; live host/presence comes from assignment in P3. */
export default function HostTabButton({ active }: { active?: boolean } = {}) {
  const { t } = useTranslation();
  const unreadChat = useUnreadStore((state) => state.chat);
  const match = useMatch({ path: PAGE_PATHS.CHAT, end: false });
  const isActive = active ?? !!match;
  return (
    <Link
      to={PAGE_PATHS.CHAT}
      aria-current={isActive ? 'page' : undefined}
      className={cn(
        'gp-tab-link -mt-5 flex flex-1 flex-col items-center gap-1 pb-2 text-[11px] font-semibold',
        isActive ? 'text-gp-pink-800' : 'text-gp-ink-900',
      )}
    >
      <span className="relative grid size-14 place-items-center rounded-full bg-gradient-to-br from-gp-pink-500 to-gp-pink-700 text-white shadow-glow ring-4 ring-white">
        <span className="font-display text-h3">M</span>
        <OnlineDot status="ONLINE" className="absolute right-0.5 bottom-0.5" />
        {unreadChat > 0 && (
          <span className="absolute -top-0.5 -right-0.5 size-3 rounded-full bg-gp-pink-700 ring-2 ring-white" />
        )}
      </span>
      {t('tabs.host')}
    </Link>
  );
}
